module.exports = __webpack_public_path__ + "static/media/talent_crown9539fdd2a99cdd02b7db2d450c5e87fb.webp";